import { TicketCreateForm } from './common/TicketForms';


export default function TicketCreate(){

  return (
    <>
      <div className="row">
        <h3 className="m-3">Создать обращение</h3>
      </div>
      <p className='ms-3 mb-0'>Обращение будет направлено выбранной лаборатории</p>
      <div className='m-3'>
        <TicketCreateForm />
      </div>
    </>
  )
}
